import moment from 'moment'
import mutations from './mutations'
import devices from '@/api/devices'

import { loadItemsBuilder, loadItemBuilder } from '../crudFactory'
const apiEndpoint = 'devices'

export default {
  namespaced: true,

  state: {
    items: {},
    invoiceHeader: '',
    invoiceFooter: ''
  },

  actions: {
    loadItems: loadItemsBuilder({ apiEndpoint }),
    loadItem: loadItemBuilder({ apiEndpoint }),
    loadCentralDevice ({ dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('loadItems')
          .then(devices => {
            const central = Object.values(devices).find(device => device.is_central)
            if (central) {
              resolve(central)
            } else {
              reject(new Error('Device not found'))
            }
          })
          .catch(error => reject(error))
      })
    },
    getHeader ({ commit }, { electronicDeviceId, headers = null }) {
      return new Promise((resolve, reject) => {
        devices.getHeader({ electronicDeviceId, headers })
          .then(response => {
            let header = response.data.items[0].data
            if (header) {
              if (header === '{empty}') {
                header = ''
              }
              commit('setInvoiceHeader', header)
            }
            resolve(header)
          })
      })
    },
    getFooter ({ commit }, { electronicDeviceId, headers = null }) {
      return new Promise((resolve, reject) => {
        devices.getFooter({ electronicDeviceId, headers })
          .then(response => {
            let footer = response.data.items[0].data
            if (footer) {
              if (footer === '{empty}') {
                footer = ''
              }
              commit('setInvoiceFooter', footer)
            }
            resolve(footer)
          })
      })
    },
    sourceFile ({ commit }, params) {
      return new Promise((resolve, reject) => {
        params.dateFrom = moment(`${params.startDate} ${params.startTime}`).format('YYYY-MM-DDTHH:mm:ss')
        params.dateTo = moment(`${params.endDate} ${params.endTime}`).format('YYYY-MM-DDTHH:mm:ss')
        devices.sourceFile(params)
          .then(response => {
            const data = response.data.items[0]
            resolve(data)
          })
          .catch(error => reject(error))
      })
    },
    getCurrentState (context, deviceId) {
      return new Promise((resolve, reject) => {
        devices.currentState({ electronicDeviceId: deviceId })
          .then(result => resolve(result))
          .catch(error => reject(error))
      })
    }
  },

  mutations: {
    ...mutations,
    setInvoiceHeader (state, header) {
      state.invoiceHeader = header
    },
    setInvoiceFooter (state, footer) {
      state.invoiceFooter = footer
    }
  }
}
